import { render, staticRenderFns } from "./Onomatopee.vue?vue&type=template&id=3c7ad7d7&scoped=true&"
import script from "./Onomatopee.vue?vue&type=script&lang=js&"
export * from "./Onomatopee.vue?vue&type=script&lang=js&"
import style0 from "./Onomatopee.vue?vue&type=style&index=0&id=3c7ad7d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7ad7d7",
  null
  
)

export default component.exports